<template>
  <scroll-layout>
    <template slot="header">
      <div v-if="pageButtons.length > 0" class="button-wrap">
        <ykc-button
          v-for="(button, index) in pageButtons"
          :key="button.id || index"
          v-bind="button"
          @click="button.handleClick(button, $event)">
          {{ button.text }}
        </ykc-button>
      </div>
      <div class="growth-value-flow-header">
        <div>
          <div>会员账号</div>
          <div class="value">{{ userInfo.memberAccount }}</div>
        </div>
        <div>
          <div>可用抵用卡(张)</div>
          <div class="value">{{ userInfo.cardCount }}</div>
        </div>
      </div>
      <ykc-search
        ref="YkcSearch"
        :data="searchData"
        :searchForm="searchParams"
        @click="handleSearchConfirm"
        @clean="handleSearchClean"></ykc-search>
    </template>
    <div>
      <ykc-table ref="YkcTable" :data="tableData" :columns="tableColumns" title="抵用卡列表">
        <template #headerButtons>
          <div class="table-header-button">
            <ykc-button type="plain" @click="exportData">导出</ykc-button>
          </div>
        </template>
        <ykc-pagination
          slot="pagination"
          ref="YkcPagination"
          :total="pageInfo.total"
          :current-page.sync="pageInfo.pageIndex"
          :page-size.sync="pageInfo.pageSize"
          @current-change="handlePaginationCurrentChange"
          @size-change="handlePaginationSizeChange"></ykc-pagination>
      </ykc-table>
    </div>
  </scroll-layout>
</template>

<script>
  import { marketManage } from '@/service/apis';
  import { offlineExport } from '@/utils';

  export default {
    name: 'GrowthValueFlow',
    data() {
      return {
        userInfo: {},
        pageButtons: [
          {
            id: '1',
            text: '返回',
            type: 'plain',
            handleClick: () => {
              this.$router.go(-1);
            },
          },
        ],
        tableData: [],

        tableColumns: [
          { label: '对外名称', prop: 'outName' },
          { label: '抵用卡编码', prop: 'userCardCouponId' },
          { label: '抵用卡名称', prop: 'cardCouponName' },
          { label: '使用状态', prop: 'usedStatusDesc' },
          { label: '剩余可用金额', prop: 'availableAmount' },
          { label: '关联活动', prop: 'activityName' },
          { label: '发放时间', prop: 'issueTime' },
        ],
        pageInfo: {
          total: 0,
          pageIndex: 1,
          pageSize: 10,
        },
        searchParams: {
          issueTime: '',
          usedStatus: '',
          userCardCouponId: '',
        },
      };
    },
    computed: {
      searchData() {
        return [
          {
            comName: 'YkcDropdown',
            key: 'usedStatus',
            label: '使用状态',
            placeholder: '请选择使用状态',
            data: [
              { id: '0', name: '未使用' },
              { id: '1', name: '使用中' },
              { id: '2', name: '已使用' },
              { id: '3', name: '已过期' },
              { id: '4', name: '已作废' },
            ],
          },
          {
            comName: 'YkcInput',
            key: 'userCardCouponId',
            label: '抵用卡编码',
            placeholder: '请输入抵用卡编码',
          },
          {
            comName: 'YkcDatePicker',
            key: 'issueTime',
            label: '发放时间',
          },
        ];
      },
    },
    created() {
      this.getDetail();
      this.searchTableList();
    },
    methods: {
      exportData() {
        const { userAccount } = this.$route.query;
        offlineExport(
          {
            downloadType: 'marketing_export',
            jsonNode: {
              cardCouponType: '1',
              downloadKey: 'c_user_card_coupon_export',
              userAccount,
              ...this.searchParams,
            },
          },
          this.pageInfo.total
        );
      },
      getDetail() {
        const { id } = this.$route.query;
        marketManage.memberDetails({ userId: id }).then(response => {
          console.log('getDetail response', response);
          this.userInfo = response;
        });
      },
      searchTableList() {
        const { userAccount } = this.$route.query;
        const data = {
          ...this.searchParams,
          size: this.pageInfo.pageSize,
          current: this.pageInfo.pageIndex,
          cardCouponType: '1',
          userAccount,
        };
        console.log('data', data);
        if (Array.isArray(data.issueTime) && data.issueTime.length === 2) {
          [data.issueStartTime, data.issueEndTime] = data.issueTime;
          delete data.issueTime;
        }
        marketManage.queryCUserCardCouponForPage(data).then(res => {
          console.log('queryCUserCardCouponForPage res', res);
          const { records, current, total } = res;
          this.tableData = records;
          this.pageInfo.pageIndex = current;
          this.pageInfo.total = total;
        });
      },
      /** 点击清空查询按钮 */
      handleSearchClean(form) {
        Object.assign(this.searchParams, form);
      },
      /** 点击查询按钮 */
      handleSearchConfirm() {
        this.pageInfo.pageIndex = 1;
        this.searchTableList();
      },
      /** 分页 change 事件监听器 */
      handlePaginationCurrentChange(current) {
        this.pageInfo.pageIndex = current;
        this.searchTableList();
      },
      /** 分页 size  change  事件监听器 */
      handlePaginationSizeChange(size) {
        this.pageInfo.pageIndex = 1;
        this.pageInfo.pageSize = size;
        this.searchTableList();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .growth-value-flow-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    padding: 16px 64px;
    border: 1px solid #eee;
    > div {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .value {
        font-weight: 600;
        font-size: 18px;
        margin-top: 8px;
      }
    }
  }
</style>
